module.exports = __webpack_public_path__ + "static/media/examption.cac2db3b.svg";